//* firebase
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail, signOut, createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { doc, getDoc, getFirestore, setDoc } from 'firebase/firestore';
import action from '../Redux Store/actions/index';
import store from '../Redux Store/store';

function saveUser(_user) {
  store.dispatch(action.authLogin(_user));
}

function getUserData(id) {
  return new Promise(async (resolve, reject) => {
    const auth = getAuth();
    const user = await auth.currentUser;
    const userRef = doc(getFirestore(), 'students', id);
    getDoc(userRef)
      .then((resp) => {
        const loggedInUser = resp.data();
        if (loggedInUser) {
          loggedInUser.docId = resp.id;
          saveUser(loggedInUser);
          resolve({success: true, loggedInUser});
        } else {
          signout().then((response) => {
            resolve({success: false, loggedInUser});
          }).catch((err) => {
            resolve({success: false, loggedInUser});
          });
        }
      })
      .catch((err) => {
        console.log('err: ', err);
        reject(err);
      });
  });
}

async function loginWithFirebase(email, password) {
  const auth = getAuth();
  let login = await signInWithEmailAndPassword(auth, email, password);
  return login;
}

async function isAuthenticated() {
  const auth = getAuth();
  const user = await auth.currentUser;
  console.log(user);
}
function signout() {
  return new Promise((resolve, reject) => {
    const auth = getAuth();
    signOut(auth)
      .then((res) => {
        console.log(res);
        store.dispatch(action.authLogout());
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}

async function resetAuthPassword(email) {
  console.log('email: ', email);
  return await sendPasswordResetEmail(getAuth(), email);
}

async function registerWithEmailAndPassword(email, password) {
  return await createUserWithEmailAndPassword(getAuth(), email, password);
}

async function registerStudentInDataBase(docID, PostBody) {
  const studentRef = doc(getFirestore(), `students`, docID);
  return await setDoc(studentRef, PostBody);
}

async function signInWithGoogle() {
  const auth = getAuth();
  const googleProvider = new GoogleAuthProvider();
  return await signInWithPopup(auth, googleProvider);
}

export {
  saveUser,
  loginWithFirebase,
  isAuthenticated,
  signout,
  getUserData,
  resetAuthPassword,
  registerWithEmailAndPassword,
  registerStudentInDataBase,
  signInWithGoogle,
};

